export default {
  icon: ' mdi-account-hard-hat',
  text: 'Profissionais',
  permissions: [
    { name: 'professionalIndex', text: 'Visualizar Profissionais', value: 0 },
    { name: 'professionalCreateEdit', text: 'Cadastrar/Editar Profissionais', value: 0 }
  ]
}